/* ==========================================================================
   Eleganz Wohnen redesign behaviour (Q4 2026). Vanilla JS, no dependencies.
   1. Hero slider        [data-ew-hero]
   2. Product tabs       [data-ew-tabs]
   3. Quick add          [data-ew-quick-add] (cards and cart upsells)
   4. Cart drawer sync   keeps the Impulse drawer in step with ANY cart change,
                         including adds made by apps such as Kaching Bundles.
   ========================================================================== */
(function () {
  'use strict';

  /* Shared cart state. Declared here on purpose: watchDrawer() below runs while this file is still
     being evaluated, so anything declared further down would still be undefined at that moment. */
  var recalcTimers = {}, recalcWatch = {}, recalcSub = {}, cartSnap = {};

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. hero slider ---------- */
  function initHero(root) {
    if (root.dataset.ewReady) return;
    root.dataset.ewReady = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-ew-hero-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-ew-hero-dots] button'));
    if (slides.length < 2) return;
    var current = 0, timer = null;
    var speed = (parseInt(root.dataset.speed, 10) || 4) * 1000;
    var autoplay = root.dataset.autoplay !== 'false' && !reducedMotion;

    /* deferred slide photos: real URLs sit in data attributes until the page has loaded */
    var hydrated = false;
    function hydrate() {
      if (hydrated) return; hydrated = true;
      root.querySelectorAll('[data-srcset], [data-src]').forEach(function (el) {
        if (el.dataset.srcset) { el.setAttribute('srcset', el.dataset.srcset); el.removeAttribute('data-srcset'); }
        if (el.dataset.src) { el.setAttribute('src', el.dataset.src); el.removeAttribute('data-src'); }
      });
    }
    if (document.readyState === 'complete') { setTimeout(hydrate, 300); }
    else { window.addEventListener('load', function () { setTimeout(hydrate, 300); }); }

    function go(n) {
      hydrate();
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!autoplay) return; stop(); timer = setInterval(function () { go(current + 1); }, speed); }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---------- 2. tabs ---------- */
  function initTabs(root) {
    if (root.dataset.ewReady) return;
    root.dataset.ewReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; if (on) panel.scrollLeft = 0; }
        });
      });
    });
  }

  /* ---------- 3. quick add ---------- */
  var cartAddUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

  /* The button stays in its waiting state until the cart markup has actually been rebuilt.
     Dropping it when the fetch resolves left half a second in which the button looked ready again
     while nothing had changed yet, which invites a second click and a double line. */
  var pendingAddBtn = null, pendingAddTimer = null;
  function pendingAddDone() {
    clearTimeout(pendingAddTimer);
    if (pendingAddBtn) { pendingAddBtn.classList.remove('is-loading'); pendingAddBtn = null; }
  }
  function pendingAddStart(btn) {
    pendingAddDone();
    pendingAddBtn = btn;
    btn.classList.add('is-loading');
    pendingAddTimer = setTimeout(pendingAddDone, 8000);   /* never stay stuck */
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-ew-quick-add');
    if (!id) return;
    pendingAddStart(btn);
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        /* same event the Impulse product form fires: rebuilds and opens the drawer */
        ewSelfTriggered = Date.now();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { addToCartBtn: btn } }));
      })
      .catch(function (err) { pendingAddDone(); window.location.href = (theme && theme.routes && theme.routes.cartPage) || '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-ew-quick-add]');
    if (!btn) return;
    e.preventDefault();
    quickAdd(btn);
  });

  /* ---------- 3a. quick-add sheet for products with variants ----------
     Opens on [data-ew-quick-view="handle"]. Product data comes from /products/<handle>.js, so
     options, prices and availability are always the live product data. */
  var S = window.ewStrings || {};
  function money(cents) { return (window.theme && theme.Currency) ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : (cents / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var qv = null;

  function buildSheet() {
    if (qv) return qv;
    qv = document.createElement('div');
    qv.className = 'ew-qv'; qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.setAttribute('aria-label', S.quickTitle || 'Schnellkauf');
    qv.innerHTML = '<div class="ew-qv__scrim" data-ew-qv-close></div><div class="ew-qv__panel"><div class="ew-qv__head"><b>' + esc(S.quickTitle || 'Schnellkauf') + '</b><button type="button" class="ew-qv__close" data-ew-qv-close aria-label="' + esc(S.close || 'Schließen') + '"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="ew-qv__body"></div></div>';
    document.body.appendChild(qv);
    qv.addEventListener('click', function (e) { if (e.target.closest('[data-ew-qv-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qv.classList.contains('is-open')) closeSheet(); });
    return qv;
  }
  function closeSheet() {
    if (!qv) return;
    qv.classList.remove('is-in');
    setTimeout(function () { qv.classList.remove('is-open'); document.documentElement.style.overflow = ''; }, 280);
  }
  function openSheet(handle, trigger) {
    buildSheet();
    trigger.classList.add('is-loading');
    fetch((S.productUrl || '/products/') + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { renderSheet(p); qv.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; requestAnimationFrame(function () { qv.classList.add('is-in'); }); })
      .catch(function () { window.location.href = (S.productUrl || '/products/') + handle; })
      .then(function () { trigger.classList.remove('is-loading'); });
  }
  function renderSheet(p) {
    var body = qv.querySelector('.ew-qv__body');
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var sel = first.options.slice();
    function variantFor(opts) { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function imageFor(optIndex, value) {
      /* a photo whose file name carries the value (dreamwrap_blau.png) beats the variant photo,
         which is sometimes a lifestyle shot that would make one swatch look different */
      var slug = String(value).toLowerCase().replace(/[\s-]+/g, '');
      var named = (p.images || []).filter(function (src) {
        var file = String(src).split('?')[0].split('/').pop().toLowerCase().replace(/\.[a-z0-9]+$/, '');
        return file.split(/[_.\s-]+/).indexOf(slug) > -1;          /* whole word: "grau" is not "hellgrau" */
      })[0];
      if (named && slug.length > 2) return named;
      var v = p.variants.filter(function (x) { return x.options[optIndex] === value && x.featured_image; })[0];
      return v ? v.featured_image.src : null;
    }
    /* Which option gets photo swatches: an option named like a colour first; otherwise the first
       option whose values each have their OWN photo. Sizes that all show the same photo stay buttons. */
    var photoOpt = -1;
    function allImages(oi, opt) {
      return opt.values.length > 1 && opt.values.every(function (val) { return imageFor(oi, val); });
    }
    function distinctImages(oi, opt) {
      var seen = {};
      return allImages(oi, opt) && opt.values.every(function (val) {
        var src = String(imageFor(oi, val)).split('?')[0];
        if (seen[src]) return false; seen[src] = 1; return true;
      });
    }
    p.options.forEach(function (opt, oi) {
      if (photoOpt < 0 && /farbe|colou?r|kleur|couleur/i.test(opt.name) && allImages(oi, opt)) photoOpt = oi;
    });
    p.options.forEach(function (opt, oi) {
      if (photoOpt < 0 && distinctImages(oi, opt)) photoOpt = oi;
    });
    function draw() {
      var v = variantFor(sel), html = '';
      var pic = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      html += '<div class="ew-qv__top"><img src="' + imgUrl(pic, 200) + '" alt=""><div><p class="ew-qv__title">' + esc(p.title) + '</p><div class="ew-qv__price">' +
        (v && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + (v ? money(v.price) : '') + '</div><a class="ew-qv__details" href="' + esc(p.url) + (v ? '?variant=' + v.id : '') + '">' + esc(S.details || 'Alle Details ansehen') + '</a></div></div>';
      p.options.forEach(function (opt, oi) {
        var useImg = oi === photoOpt;
        html += '<div><div class="ew-qv__label">' + esc(opt.name) + '<b>' + esc(sel[oi]) + '</b></div><div class="ew-qv__opts' + (useImg ? '' : ' ew-qv__opts--grid') + '">';
        opt.values.forEach(function (val) {
          var test = sel.slice(); test[oi] = val; var tv = variantFor(test), off = !tv || !tv.available;
          html += '<button type="button" class="ew-qv__opt' + (useImg ? ' ew-qv__opt--img' : '') + (off ? ' is-off' : '') + '" data-oi="' + oi + '" data-val="' + esc(val) + '" aria-pressed="' + (sel[oi] === val) + '"' + (useImg ? ' aria-label="' + esc(val) + '" title="' + esc(val) + '"' : '') + '>' +
            (useImg ? '<img src="' + imgUrl(imageFor(oi, val), 120) + '" alt="">' : esc(val)) + '</button>';
        });
        html += '</div></div>';
      });
      var ok = v && v.available;
      html += '<button type="button" class="ew-btn ew-qv__add"' + (ok ? ' data-vid="' + v.id + '"' : ' disabled') + '>' + (ok ? esc(S.add || 'In den Warenkorb') + ' — ' + money(v.price) : esc(S.soldOut || 'Ausverkauft')) + '</button>';
      body.innerHTML = html;
    }
    body.onclick = function (e) {
      var o = e.target.closest('.ew-qv__opt');
      if (o) { sel[+o.dataset.oi] = o.dataset.val; draw(); return; }
      var add = e.target.closest('.ew-qv__add');
      if (add && add.dataset.vid) { add.setAttribute('data-ew-quick-add', add.dataset.vid); closeSheet(); quickAdd(add); }
    };
    draw();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button[data-ew-quick-view]');
    if (!t) return;
    e.preventDefault();
    openSheet(t.getAttribute('data-ew-quick-view'), t);
  });

  /* ---------- 3b. remove a line from the drawer without leaving the page ----------
     The trash icon is a normal /cart/change link (works without JS). With JS we post the
     change and let the cart sync below rebuild the drawer. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('#CartDrawer .cart__remove a');
    if (!link) return;
    var item = link.closest('.cart__item');
    var key = item && item.getAttribute('data-key');
    if (!key) return;
    e.preventDefault();
    item.style.opacity = '.4';
    fetch(((window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { if (!r.ok) window.location.href = link.href; })
      .catch(function () { window.location.href = link.href; });
  });

  /* ---------- 4. cart drawer sync ----------
     Impulse rebuilds its drawer on the events `cart:build` and `ajaxProduct:added`.
     Apps (Kaching Bundles etc.) add to the cart with their own fetch/XHR calls, so the
     theme never hears about it. We watch every request to /cart/add|change|update|clear
     and, when it succeeded and was NOT started by the theme itself, rebuild the drawer.
     An add also opens the drawer. Debounced, so one action never rebuilds twice. */
  var ewSelfTriggered = 0, rebuildTimer = null, lastThemeEvent = 0;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  document.addEventListener('ajaxProduct:added', function () { lastThemeEvent = Date.now(); });
  document.addEventListener('cart:updated', function () { lastThemeEvent = Date.now(); });

  function isDrawerTheme() { return window.theme && theme.settings && theme.settings.cartType === 'drawer' && document.getElementById('CartDrawer'); }

  function scheduleRebuild(isAdd) {
    if (!isDrawerTheme()) return;
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(function () {
      /* the theme (or our own quick add) already handled this change */
      if (Date.now() - lastThemeEvent < 900 || Date.now() - ewSelfTriggered < 900) return;
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (isAdd) document.dispatchEvent(new CustomEvent('cart:open'));
    }, 350);
  }

  function watch(url, ok) {
    if (!ok || !url) return;
    var m = CART_WRITE.exec(String(url).split('#')[0]);
    if (m) scheduleRebuild(m[1] === 'add');
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      return nativeFetch.apply(this, arguments).then(function (res) {
        try { watch(url, res && res.ok); } catch (e) {}
        return res;
      });
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () { try { watch(url, this.status >= 200 && this.status < 300); } catch (e) {} });
      return open.apply(this, arguments);
    };
  }

  /* ---------- 5. old total next to the subtotal ----------
     cart.ajax.liquid puts the subtotal and the really applied discount (no compare-at prices) on `.cart__items`.
     Whenever Impulse swaps the drawer items we show subtotal + discount as the struck-through old total. */
  function syncWasTotal() {
    /* the drawer and the cart page (/cart) use the same markup and the same rule */
    ['CartDrawer', 'CartPageForm'].forEach(function (id) {
      var box = document.getElementById(id); if (!box) return;
      var was = box.querySelector('[data-ew-was]'), items = box.querySelector('.cart__items');
      if (!was || !items) return;
      var sub = parseInt(items.dataset.cartSubtotal, 10) || 0, saved = parseInt(items.dataset.cartSavings, 10) || 0;
      if (saved > 0 && window.theme && theme.Currency) {
        was.innerHTML = theme.Currency.formatMoney(sub + saved, theme.settings.moneyFormat);
        was.hidden = false;
      } else { was.hidden = true; }
    });
  }
  /* ---------- 5b. smart upsells in the cart ----------
     The rail arrives from Liquid already filled (same category or bestsellers). Here we try to improve it for the
     most recently added product: first the merchant's manual picks (intent=complementary, set per product in
     Shopify Search & Discovery), then Shopify's automatic related products. Results are cached per cart state. */
  var recCache = {};
  function recUrl(id, intent) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'recommendations/products?section_id=ew-cart-recommendations&product_id=' + id + '&limit=10&intent=' + intent;
  }
  function fetchRec(id, intent) {
    return fetch(recUrl(id, intent)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), box = doc.querySelector('[data-ew-rec]');
      return box ? { html: box.innerHTML.trim(), count: box.querySelectorAll('.ew-up').length } : { html: '', count: 0 };
    }).catch(function () { return { html: '', count: 0 }; });
  }
  function smartUpsells() {
    var up = document.querySelector('#CartDrawer [data-ew-up]');
    if (!up || up.dataset.smart !== 'true' || up.dataset.done) return;
    var id = up.dataset.productId, rail = up.querySelector('[data-ew-up-rail]');
    if (!id || !rail) return;
    var key = id + '|' + [].map.call(document.querySelectorAll('#CartDrawer .cart__item'), function (i) { return i.getAttribute('data-key'); }).join(',');
    up.dataset.done = '1';
    function apply(res, source) { if (!document.body.contains(up)) return; rail.innerHTML = res.html; rail.scrollLeft = 0; up.hidden = false; up.dataset.source = source; }
    if (recCache[key]) { if (recCache[key].html) apply(recCache[key], recCache[key].source); return; }
    fetchRec(id, 'complementary').then(function (c) {
      if (c.count >= 1) { c.source = 'complementary'; recCache[key] = c; apply(c, 'complementary'); return; }
      if (up.dataset.related === 'false') { recCache[key] = { html: '' }; return; }   /* keep the category rail from Liquid */
      return fetchRec(id, 'related').then(function (r) {
        if (r.count >= 2) { r.source = 'related'; recCache[key] = r; apply(r, 'related'); }
        else recCache[key] = { html: '' };
      });
    });
  }

  /* ---------- 5c. no empty cart while the drawer is still loading ----------
     Impulse opens the drawer and only then fetches the cart, so on the first add the visitor sees the
     empty-cart panel for about a second. From the moment something is added we mark the drawer busy:
     the empty panel is hidden and a placeholder row takes its place until the real items arrive. */
  function cartBusy(on) {
    var drawer = document.getElementById('CartDrawer'); if (!drawer) return;
    var holder = drawer.querySelector('[data-products]');
    drawer.classList.toggle('ew-busy', !!on);
    if (!holder) return;
    var skel = holder.querySelector('.ew-cart-skel');
    if (on && !skel && !holder.querySelector('.cart__item')) {
      skel = document.createElement('div');
      skel.className = 'ew-cart-skel';
      skel.setAttribute('aria-hidden', 'true');
      skel.innerHTML = '<div class="ew-cart-skel__row"><span class="ew-cart-skel__img"></span>' +
        '<span class="ew-cart-skel__lines"><i></i><i></i><i></i></span></div>';
      holder.appendChild(skel);
    } else if (!on && skel) {
      skel.remove();
    }
  }
  var busyTimer = null;
  function cartBusyStart() {
    cartBusy(true);
    clearTimeout(busyTimer);
    busyTimer = setTimeout(function () { cartBusy(false); }, 8000);   /* never stay stuck */
  }
  /* Only when new markup is actually on its way: after an add (theme or ours) and on a rebuild.
     Never on a plain "open", or an empty cart would sit behind a placeholder that never resolves. */
  ['ajaxProduct:added', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, function () { cartBusyStart(); });
  });

  function watchCartPage() {
    var holder = document.querySelector('#CartPageForm [data-products]');
    if (!holder || !window.MutationObserver) return;
    new MutationObserver(function () {
      recalcOff(); pendingAddDone();
      animateCartChange(document.getElementById('CartPageForm'));
      syncWasTotal();
    }).observe(holder, { childList: true });
    animateCartChange(document.getElementById('CartPageForm'));   /* seeds the snapshot, animates nothing */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCartPage); else watchCartPage();

  function watchDrawer() {
    var holder = document.querySelector('#CartDrawer [data-products]');
    if (!holder || !window.MutationObserver) return;
    new MutationObserver(function (records) {
      /* adding the placeholder itself is a change too: ignore it, otherwise it clears its own state */
      var onlySkeleton = records.every(function (r) {
        var nodes = [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes));
        return nodes.length > 0 && nodes.every(function (n) {
          return n.nodeType === 1 && n.classList && n.classList.contains('ew-cart-skel');
        });
      });
      if (onlySkeleton) return;
      clearTimeout(busyTimer); cartBusy(false); recalcOff(); pendingAddDone();
      animateCartChange(document.getElementById('CartDrawer'));
      syncWasTotal(); smartUpsells();
    }).observe(holder, { childList: true });
    syncWasTotal(); smartUpsells();
    animateCartChange(document.getElementById('CartDrawer'));   /* seeds the snapshot, animates nothing */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();

  /* ---------- 5d. feedback while the cart is recalculating ----------
     Impulse only dims the little stepper and leaves the prices on screen for about a second and a half
     after a quantity change or a removal, so the cart looks stuck. From the click until the new markup
     lands we mark the whole cart "recalculating": steppers, remove links and the checkout button go
     inert and a small spinner sits next to the total. Works in the drawer and on the cart page. */
  function cartScope(el) { return el.closest ? el.closest('#CartDrawer, #CartPageForm') : null; }
  function subText(scope) { var s = scope.querySelector('[data-subtotal]'); return s ? s.textContent.trim() : ''; }
  function recalc(scope, on) {
    if (!scope) return;
    var id = scope.id || 'cart';
    scope.classList.toggle('ew-recalc', !!on);
    clearTimeout(recalcTimers[id]); clearInterval(recalcWatch[id]);
    if (on) {
      recalcSub[id] = subText(scope);
      recalcTimers[id] = setTimeout(function () { recalc(scope, false); }, 8000);   /* never stay stuck */
    }
  }
  /* Impulse replaces the items first and the totals a few hundred milliseconds later. Stopping on the
     items alone would leave the old price on screen without any sign that it is still changing, so we
     keep spinning until the subtotal itself has been rewritten (or three seconds have passed). */
  function recalcOff() {
    ['CartDrawer', 'CartPageForm'].forEach(function (id) {
      var scope = document.getElementById(id);
      if (!scope || !scope.classList.contains('ew-recalc')) return;
      if (subText(scope) !== recalcSub[id]) { recalc(scope, false); return; }
      clearInterval(recalcWatch[id]);
      var waited = 0;
      recalcWatch[id] = setInterval(function () {
        waited += 80;
        if (subText(scope) !== recalcSub[id] || waited > 3000) { clearInterval(recalcWatch[id]); recalc(scope, false); }
      }, 80);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-qty__adjust, .cart__remove a, [data-ew-cart-remove]');
    if (t) recalc(cartScope(t), true);
  });
  document.addEventListener('change', function (e) {
    var n = e.target.closest && e.target.closest('.js-qty__num, .js-qty__input');
    if (n) recalc(cartScope(n), true);
  });
  document.addEventListener('cart:updated', recalcOff);

  /* Coming back from the checkout restores the page from the browser cache, spinner and all.
     Wipe every waiting state so nobody stares at a button that will never finish. */
  window.addEventListener('pageshow', function () {
    [].forEach.call(document.querySelectorAll('.btn--loading, .is-loading, .ew-recalc'), function (el) {
      el.classList.remove('btn--loading'); el.classList.remove('is-loading'); el.classList.remove('ew-recalc');
    });
  });

  /* ---------- 5e. a new line arrives instead of popping ----------
     Every cart change re-renders the whole list, so a line added from the rail in the cart simply
     appeared. We compare the keys and quantities with the previous render: a key we had not seen
     fades and slides in, a line that only grew flashes once. Never on the first render. */
  function lineQty(el) {
    var q = el.querySelector('.js-qty__num, input[name="updates[]"], [data-quantity]');
    return q ? (parseInt(q.value || q.getAttribute('data-quantity'), 10) || 1) : 1;
  }
  /* The rail sits under the list, so a line added from it lands just above the fold. If it is not
     fully in view, the cart scrolls to it instead of leaving the visitor guessing. */
  function scrollerOf(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var cs = window.getComputedStyle(n);
      if (/auto|scroll/.test(cs.overflowY) && n.scrollHeight > n.clientHeight + 2) return n;
    }
    return null;
  }
  function revealLine(el) {
    var sc = scrollerOf(el); if (!sc || !sc.scrollTo) return;
    var r = el.getBoundingClientRect(), b = sc.getBoundingClientRect();
    if (r.top >= b.top && r.bottom <= b.bottom) return;
    try { sc.scrollTo({ top: sc.scrollTop + (r.top - b.top) - 16, behavior: reducedMotion ? 'auto' : 'smooth' }); }
    catch (e) { sc.scrollTop = sc.scrollTop + (r.top - b.top) - 16; }
  }
  function animateCartChange(scope) {
    if (!scope) return;
    var id = scope.id || 'cart', prev = cartSnap[id], now = {};
    [].forEach.call(scope.querySelectorAll('.cart__item[data-key]'), function (el) {
      var key = el.getAttribute('data-key');
      now[key] = lineQty(el);
      if (!prev) return;
      if (!(key in prev)) {
        el.classList.add('ew-new');
        revealLine(el);
        /* one frame is not enough: the browser would skip the transition */
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
        setTimeout(function () { el.classList.remove('ew-new', 'is-in'); }, 700);
      } else if (now[key] > prev[key]) {
        el.classList.add('ew-bump');
        setTimeout(function () { el.classList.remove('ew-bump'); }, 700);
      }
    });
    cartSnap[id] = now;
  }

  /* ---------- 6. photo swatches: show the chosen value next to the option name ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.ew-vswatch [data-variant-input]')) return;
    var out = input.closest('.ew-vswatch').querySelector('[data-ew-option-value]');
    if (out) out.textContent = input.value;
  });

  /* ---------- 7. sticky buy bar ----------
     Layout after the merchant's reference: thumbnail, title, price (+ old price), then variant select,
     quantity and the button. Everything is a remote control for the REAL product form:
     - the button clicks the real buy button (variant, quantity and app logic such as Kaching Bundles stay in charge)
     - the select picks the matching option buttons of the real form
     - the quantity box only shows when the real form has a visible quantity field (bundle apps replace it) */
  function initSticky() {
    if (!(window.ewStrings && ewStrings.stickyAtc)) return;
    var main = document.querySelector('.product-single__form .add-to-cart, form[action*="/cart/add"] .add-to-cart');
    var titleEl = document.querySelector('.product-single__title');
    if (!main || !titleEl || document.querySelector('.ew-sticky')) return;
    var form = main.closest('form');
    var idField = form && form.querySelector('[name="id"]');
    var og = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');
    var imgEl = og && og.content ? { src: og.content.replace(/^http:/, 'https:') } : null;
    var bar = document.createElement('div');
    bar.className = 'ew-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ew-sticky__info">' + (imgEl ? '<img class="ew-sticky__img" alt="" src="' + imgUrl(imgEl.src, 160) + '">' : '') +
      '<div class="ew-sticky__txt"><div class="ew-sticky__title"></div><div class="ew-sticky__price"><span data-now></span><s data-was></s></div></div></div>' +
      '<div class="ew-sticky__row"><select class="ew-sticky__select" aria-label="Variante" hidden></select>' +
      '<div class="ew-sticky__qty" hidden><button type="button" data-d="-1" aria-label="-">−</button><span>1</span><button type="button" data-d="1" aria-label="+">+</button></div>' +
      '<button type="button" class="ew-btn ew-sticky__btn"></button></div>';
    document.body.appendChild(bar);
    bar.querySelector('.ew-sticky__title').textContent = titleEl.textContent.trim();
    var btn = bar.querySelector('.ew-sticky__btn'), nowOut = bar.querySelector('[data-now]'), wasOut = bar.querySelector('[data-was]');
    var select = bar.querySelector('select'), qtyBox = bar.querySelector('.ew-sticky__qty'), qtyOut = qtyBox.querySelector('span');
    var product = null;

    /* variants: read once from the product JSON, only when there is something to choose */
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (handle && idField) {
      fetch(((window.ewStrings && ewStrings.productUrl) || '/products/') + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          product = p;
          if (p.variants.length < 2) return;
          select.innerHTML = p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>'; }).join('');
          select.hidden = false; sync();
        }).catch(function () {});
    }
    select.addEventListener('change', function () {
      if (!product) return;
      var v = product.variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      var touched = false;
      v.options.forEach(function (val, i) {
        var inputs = form ? form.ownerDocument.querySelectorAll('[data-index="option' + (i + 1) + '"] [data-variant-input], select[data-index="option' + (i + 1) + '"]') : [];
        [].forEach.call(inputs, function (el) {
          if (el.tagName === 'SELECT') { if (el.value !== val) { el.value = val; el.dispatchEvent(new Event('change', { bubbles: true })); touched = true; } }
          else if (el.value === val && !el.checked) { el.click(); touched = true; }
        });
      });
      if (!touched && idField) { idField.value = v.id; idField.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    /* quantity: mirror the real field, only if the customer can see one */
    /* Kaching loads hidden config on every page; only a VISIBLE bundle block means the app governs the quantity */
    function hasBundleApp() { var k = document.querySelector('kaching-bundles-block, .kaching-bundles__block'); return !!(k && k.getBoundingClientRect().height > 0); }
    function realQty() {
      if (!form || hasBundleApp()) return null;
      var q = form.querySelector('input[name="quantity"]');
      if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = 1; q.setAttribute('data-ew-qty', ''); form.appendChild(q); }
      return q;
    }
    qtyBox.addEventListener('click', function (e) {
      var b = e.target.closest('button'), q = realQty(); if (!b || !q) return;
      var n = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.d, 10));
      q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); qtyOut.textContent = n;
    });

    function sync() {
      var label = main.querySelector('[data-add-to-cart-text]') || main;
      btn.textContent = label.textContent.trim();
      btn.disabled = main.disabled;
      var price = document.querySelector('[data-product-price]'), was = document.querySelector('[data-compare-price]'), wasWrap = document.querySelector('[data-product-price-wrap]');
      if (price) nowOut.textContent = price.textContent.trim();
      var showWas = was && was.textContent.trim() && !(wasWrap && wasWrap.classList.contains('hide'));
      wasOut.textContent = showWas ? was.textContent.trim() : '';
      if (idField && !select.hidden && idField.value && select.value !== String(idField.value)) select.value = String(idField.value);
      if (product && idField) { var cv = product.variants.filter(function (x) { return String(x.id) === String(idField.value); })[0]; var im = bar.querySelector('.ew-sticky__img'); if (cv && cv.featured_image && im) im.src = imgUrl(cv.featured_image.src, 160); }
      var q = realQty(); qtyBox.hidden = !q; if (q) qtyOut.textContent = q.value || 1;
    }
    sync();
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(document.querySelector('.product-single__meta') || form || main, { subtree: true, childList: true, characterData: true, attributes: true });
    }
    document.addEventListener('change', function () { setTimeout(sync, 60); });
    btn.addEventListener('click', function () { main.click(); });

    function place() {
      var r = main.getBoundingClientRect();
      var cls = document.documentElement.className + ' ' + document.body.className;
      var blocked = /js-drawer-open|modal-open/.test(cls) || !!document.querySelector('.ew-qv.is-open');
      var on = r.bottom < 0 && !blocked;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    window.addEventListener('scroll', place, { passive: true }); window.addEventListener('resize', place);
    if (window.MutationObserver) {
      var mo = new MutationObserver(place);
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    place();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();

  /* ---------- 8. stepped recommendations on the product page ----------
     Fills the "Andere kauften auch" row in this order, without duplicates, until the row is full:
     manual picks (complementary) -> Shopify related -> same category -> fallback collection.
     The cards are the theme's own product cards, rendered by Shopify through the section's endpoint. */
  function initSmartRecs(box) {
    if (!box || box.dataset.ewSmart !== 'true' || box.dataset.ewRecDone) return;
    box.dataset.ewRecDone = '1';
    var id = box.dataset.productId, limit = parseInt(box.dataset.limit, 10) || 5, url = box.dataset.url;
    var placeholder = box.querySelector('.product-recommendations-placeholder'); if (!placeholder || !url) return;
    function cards(intent) {
      return fetch(url + '?section_id=product-recommendations&limit=' + (limit + 2) + '&product_id=' + id + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); return [].slice.call(d.querySelectorAll('.product-recommendations .grid-product')); })
        .catch(function () { return []; });
    }
    /* mode "category": use only what the page already contains (same category, then bestsellers); nothing is fetched */
    var steps = box.dataset.ewMode === 'stepped' ? Promise.all([cards('complementary'), cards('related')]) : Promise.resolve([[], []]);
    steps.then(function (res) {
      var fallback = [].slice.call(box.querySelectorAll('.ew-rec-fallback .grid-product'));
      var seen = {}, out = [], sources = { complementary: 0, related: 0, fallback: 0 };
      seen[id] = true;
      [['complementary', res[0]], ['related', res[1]], ['fallback', fallback]].forEach(function (step) {
        step[1].forEach(function (el) {
          var pid = el.getAttribute('data-product-id');
          if (!pid || seen[pid] || out.length >= limit) return;
          seen[pid] = true; sources[step[0]]++; out.push(el);
        });
      });
      if (!out.length) { box.classList.add('hide'); return; }
      var wrap = document.createElement('div'); wrap.className = 'product-recommendations';
      var grid = document.createElement('div'); grid.className = 'grid grid--uniform';
      out.forEach(function (el) { el.removeAttribute('data-aos'); grid.appendChild(document.importNode(el, true)); });
      wrap.appendChild(grid); placeholder.innerHTML = ''; placeholder.appendChild(wrap);
      box.dataset.ewSources = JSON.stringify(sources);
      var fb = box.querySelector('.ew-rec-fallback'); if (fb) fb.remove();
      if (window.theme && theme.reinitProductGridItem) { try { theme.reinitProductGridItem(box); } catch (e) {} }
      document.dispatchEvent(new CustomEvent('recommendations:loaded', { detail: { section: box } }));
    });
  }
  function watchRecs() {
    [].forEach.call(document.querySelectorAll('[data-section-type="product-recommendations"][data-ew-smart="true"]'), function (box) {
      if (!window.IntersectionObserver) { initSmartRecs(box); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); initSmartRecs(box); } }, { rootMargin: '700px 0px' });
      io.observe(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchRecs); else watchRecs();

  /* ---------- 10. announcement bar: the promises take turns ----------
     One message is visible, the rest wait in the same grid cell. Nothing happens while the tab is
     in the background, so nobody comes back to a bar mid-fade. */
  function initAnnounce(stack) {
    if (stack.dataset.ewReady) return;
    stack.dataset.ewReady = '1';
    var msgs = stack.querySelectorAll('.ew-ann__msg');
    var every = parseInt(stack.getAttribute('data-rotate'), 10) || 3000;
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, every);
  }

  /* ---------- boot (also re-runs in the theme editor) ---------- */
  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ew-hero]'), initHero);
    [].forEach.call((scope || document).querySelectorAll('[data-ew-tabs]'), initTabs);
    [].forEach.call((scope || document).querySelectorAll('[data-ew-announce]'), initAnnounce);
  }
  /* a link to any page ending in #ew-cart opens the cart drawer */
  window.addEventListener('load', function () {
    if (location.hash === '#ew-cart') setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:open')); }, 600);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-ew-hero-slide]');
    if (!slide) return;
    var hero = slide.closest('[data-ew-hero]');
    [].forEach.call(hero.querySelectorAll('[data-ew-hero-slide]'), function (s) { s.classList.toggle('is-active', s === slide); });
  });

  /* ---------- 9. colour tiles on the product page ----------
     A tile is a plain link to its variant, so it works without JS. With JS we keep the visitor on
     the page: pick that colour in whatever variant picker the page uses (the theme's own radios,
     Swatch King, or the fallback select) and scroll back up to the gallery. Pickers inside product
     cards, the cart drawer and the Kaching bundle rows are ignored: those are not the main product. */
  function colorTiles() {
    var box = document.querySelector('[data-ew-colors]'); if (!box) return;
    var name = (box.dataset.option || '').toLowerCase();

    function isMain(el) {
      return !el.closest('.grid-product, .ew-card, .ew-up, #CartDrawer, [class*="kaching"]');
    }
    function picker(value) {
      var i, list;
      list = document.querySelectorAll('input[type="radio"]');
      for (i = 0; i < list.length; i++) {
        if (list[i].value === value && (list[i].name || '').toLowerCase().indexOf(name) > -1 && isMain(list[i])) return list[i];
      }
      list = document.querySelectorAll('.swatch-selector[data-value]');   /* Swatch King */
      for (i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-value') === value && isMain(list[i])) return list[i];
      }
      list = document.querySelectorAll('select');
      for (i = 0; i < list.length; i++) {
        if (!isMain(list[i])) continue;
        for (var j = 0; j < list[i].options.length; j++) {
          if (list[i].options[j].value === value) return list[i];
        }
      }
      return null;
    }
    function values() {
      return Array.prototype.map.call(box.querySelectorAll('.ew-pdp-color'), function (a) { return a.dataset.value; });
    }
    function current() {
      /* the page has one picker per option, so only count a selection that is one of our colours */
      var mine = values(), i;
      var sel = document.querySelectorAll('.swatch-selector.swatch-selected[data-value]');
      for (i = 0; i < sel.length; i++) {
        if (isMain(sel[i]) && mine.indexOf(sel[i].getAttribute('data-value')) > -1) return sel[i].getAttribute('data-value');
      }
      var r = document.querySelectorAll('input[type="radio"]:checked');
      for (i = 0; i < r.length; i++) {
        if (isMain(r[i]) && mine.indexOf(r[i].value) > -1) return r[i].value;
      }
      return '';
    }
    function mark() {
      var value = current();
      box.querySelectorAll('.ew-pdp-color').forEach(function (a) {
        a.classList.toggle('is-active', !!value && a.dataset.value === value);
      });
    }
    box.addEventListener('click', function (e) {
      var tile = e.target.closest('.ew-pdp-color'); if (!tile) return;
      var hit = picker(tile.dataset.value);
      if (!hit) return;                                   /* nothing found: follow the link */
      e.preventDefault();
      if (hit.tagName === 'SELECT') {
        hit.value = tile.dataset.value;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        hit.click();
      }
      var gallery = document.querySelector('.product-single__media-group, .product-single__photos, .product__photos');
      if (gallery) { gallery.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      setTimeout(mark, 120);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.swatch-selector')) setTimeout(mark, 150);
    });
    document.addEventListener('change', function () { setTimeout(mark, 60); });
    setTimeout(mark, 800);
  }
  colorTiles();

})();
